import React, { Component } from "react";
import { Form, Button, Card, Nav, Tab, Row, Col } from "react-bootstrap";
import Header from "./Header";
import Footer from "./Footer";
import HeaderIntroCompliance from "./HeaderIntroCompliance";
import BusinessRegistrationProcess from "./BusinessRegistrationProcess";
import NewsLetter from "./NewsLetter";
export class CorporateComplince extends Component {
  render() {
    return (
      <div>
        <Header />
        <div>
          <HeaderIntroCompliance />
        </div>

        <section
          id="services"
          class="section-bg"
          style={{ backgroundColor: "#f3f9fd" }}
        >
          <div class="container" data-aos="fade-up">
            <header class="section-header">
              <h3>Corporate Compliance</h3>
              <p>
                We will guide you through the Laws and Rules and ensure the due
                diligence of legislation. After procuring complete information
                from your organization we can ensure and help you in conducting
                the affairs of the company as per the law. We will also ensure a
                timely correction and rectification of any lapses in the
                compliance of provisions of various statues.
              </p>
              <br />
            </header>

            {/* <Card>
              <Card.Header style={{backgroundColor:"#004767", color:"#fff", fontSize:18}}>Closure/Changes in Business</Card.Header>
              <Card.Body>
             
                <Card.Text style={{color:"#000", fontSize:14, alignSelf:"center"}}>
                    Cliptax can help you easily wind up the company within few
                    months. Cliptax provides additional service of reviewing the
                    status of the company and to decide if the company is ready
                    for winding up or not. Our Professionals will also assist
                    you with all the essential documentation for the process of
                    application to the Ministry of Corporate Finance (MCA)
                    winding up of a company.
                    <br /> 
                    Change is the new constant these days. Cliptax
                    supports your decision to change and helps you for the
                    process of conversion. We provide different services when it
                    comes to making changes for your organization. Be it Adding
                    or Removing a Director or a designated partner; Changing
                    objectives of your business; Changing your name of the
                    company or the official address of the company; changing the
                    course of business or even changing the LLP agreements, we
                    are glad to be of your service. Want a fresh start? Catch up
                    with us now and get solutions to all your problems.
                </Card.Text>
            
              </Card.Body>
            </Card> */}

          </div>
        </section>
        <NewsLetter />
        <Footer />
      </div>
    );
  }
}

export default CorporateComplince;
